import React, { useState, useContext, useEffect, useRef  } from "react";
import { useParams } from "react-router-dom";
import "./UGGridLayout.css";
import "../../UserAccountGridLayout.css";
import UGGridCentreUpperLayout from "./Layout/UGGridCentreUpperLayout";
import UserPostCentreLayout from "../../Layout/UserAccountGridCenter"; // ✅ Import UserPostCentreLayout
import { ThemeContext } from "../../../../../context/ThemeContext";
import "../../Styles/ua-common-styles.css";
import PageProfileModal from "../../../../common/PopupPages/PageProfile";
import UGGridCentreLowerLayout from "./Layout/UGGridCentreLowerLayout";
import { fetchFeedDataForGroups } from "./Utils/UGFetchFeeddata.js";


const UGPageGridLayout = () => {
  const [selectedProfileId, setSelectedProfileId] = useState(null);
  const { theme } = useContext(ThemeContext);
  const [renderOperation, setRenderOperation] = useState(null);
  const [activetab, setActivetab] = useState(""); // ✅ Changed from "feed" to "" for consistency
  const [displayMode, setDisplayMode] = useState("grid"); // ✅ Add displayMode state
  const { userid } = useParams();

  const [currentGroups, setCurrentGroups] = useState([]);
  const [suggestedGroups, setSuggestedGroups] = useState([]);
  const [filteredGroups, setFilteredGroups] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);
  const [selectedGroups, setSelectedGroups] = useState([]);
  const [activeTab, setActiveTab] = useState("current");
  const moreButtonRef = useRef(null);

  useEffect(() => {
    import(`./Styles/themes/${theme}/themes.css`)
      .then(() => {
        console.log(`Loaded ${theme} styles for UserProfile`);
      })
      .catch(() => {
        console.error(`Theme CSS not found for ${theme}`);
      });
  }, [theme]);

    // ✅ Fetch groups on mount
    useEffect(() => {
      const fetchGroups = async () => {
        try {
          const data = await fetchFeedDataForGroups();
          setCurrentGroups(data.groupList || []);
          setSuggestedGroups(data.suggestedGroupList || []);
        } catch (error) {
          console.error("Error fetching groups:", error);
        }
      };
      fetchGroups();
    }, []);
  
    // ✅ Filter groups based on search query
    useEffect(() => {
      const groupsToFilter = activeTab === "current" ? currentGroups : suggestedGroups;
      
      if (searchQuery.trim() === "") {
        setFilteredGroups(groupsToFilter);
      } else {
        const filtered = groupsToFilter.filter((group) =>
          group.groupid?.toLowerCase().includes(searchQuery.toLowerCase()) ||
          group.description?.toLowerCase().includes(searchQuery.toLowerCase())
        );
        setFilteredGroups(filtered);
      }
    }, [searchQuery, activeTab, currentGroups, suggestedGroups]);

  const handleCloseModal = () => {
    setRenderOperation(null);
  };

    // ✅ Handle group selection
    const handleGroupSelect = (groupId) => {
      setSelectedGroups((prev) =>
        prev.includes(groupId)
          ? prev.filter((id) => id !== groupId)
          : [...prev, groupId]
      );
    };

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <div className={`uaf-page-grid`} style={{ display: "flex", flexDirection: "column"}}>
        {/* ✅ Middle Container - Conditional Rendering */}
        <div style={{width: "100%", height: "100px"}}>
        <main className="uaf-middle-container" style={{background: "none"}}>
          {activetab !== "" ? (
            // ✅ Render UserPostCentreLayout when activetab is NOT empty
            <UserPostCentreLayout
              pagetype="feed"
              mediaDisplayMode={displayMode}
              userId={userid}
              activetab={activetab}
            />
          ) : (
            // ✅ Render UGGridCentreUpperLayout when activetab is empty (shows groups list)
            <UGGridCentreUpperLayout
              renderOperation={renderOperation}
              setRenderOperation={setRenderOperation}
              activetab={activetab}
            />
          )}
        </main>
        </div>
        {/* ⭐ LOWER SECTION - Groups List */}
        <div className="ua-bottom-container" style={{ marginLeft: 20, background: "none" }}>
          <UGGridCentreLowerLayout
            groups={currentGroups}
            selectedGroups={suggestedGroups}
            onGroupSelect={handleGroupSelect}
            renderOperation={renderOperation}
            setRenderOperation={setRenderOperation}
            activeTab={activeTab}
          />
      </div>
      </div>

      {/* ✅ Modal rendered here once, not per group */}
      {["messaging", "audio", "video"].includes(renderOperation?.operationType) && (
        <PageProfileModal
          userId={renderOperation.data.userId}
          operationType={renderOperation.operationType}
          mode={renderOperation.mode}
          onClose={handleCloseModal}
        />
      )}

      {/* Copyright Footer */}
      <div style={{ justifyContent: "center", display: "flex", marginTop: 20 }}>
        <p className="cmn-copyright">
          Oowlet - A Hybrid Model Social Network, Copyright © InitiumNet Technology Pvt Ltd.
        </p>
      </div>
    </div>
  );
};

export default UGPageGridLayout;
